export function servicesAbout() {

    const servicesAboutShow = document.querySelector('.js-servicesAboutShow');

    if (!servicesAboutShow) {
        return false;
    }

    servicesAboutShow.addEventListener('click', function() {
        const servicesAboutText = this.parentNode.querySelector('.js-servicesAboutText');
        this.classList.toggle('is-active');
        servicesAboutText.classList.toggle('is-active');

        let text = this.classList.contains('is-active') ? 'Скрыть' : 'Читать полностью';
        this.textContent = text;
    });
}